import { useCallback, useEffect, useState } from "react";
import { PppoeUserService } from "../services/PppoeUserService";

export const useHookPppoeUser = () => {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [params, setParams] = useState({
    search: "",
    nas_id: "",
    pop_id: "",
    odc_id: "",
    odp_id: "",
    page: 1,
    per_page: 10,
    sort_by: "created_at",
    sort_dir: "desc",
  });

  /* ── Bersihkan param kosong agar tidak dikirim ke backend ── */
  const cleanParams = useCallback((raw) => {
    const cleaned = {};
    Object.entries(raw).forEach(([key, val]) => {
      if (val !== "" && val !== null && val !== undefined) {
        cleaned[key] = val;
      }
    });
    return cleaned;
  }, []);

  const getData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await PppoeUserService.get({
        params: cleanParams(params),
      });

      setData(res?.data?.data ?? []);
      setMeta(res?.data?.meta ?? null);
    } catch (err) {
      console.error(err);
      setError(err?.response?.data || err);
    } finally {
      setLoading(false);
    }
  }, [params, cleanParams]);

  useEffect(() => {
    getData();
  }, [getData]);

  return {
    data,
    meta,
    loading,
    error,
    params,
    setParams,
    refreshData: getData,
  };
};